// @core/api/endpoints/apikey/create_api_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateAPIKeyRequest,
  CreateAPIKeyResponse,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Create API key
 * Generates a new API key with specified scopes, permissions, and restrictions. Returns the full key value which is only shown once and cannot be retrieved later.
 */
export async function CreateAPIKey(
  data: CreateAPIKeyRequest,
  options?: RequestOptions
): Promise<CreateAPIKeyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/api-keys`;
  const requestOptions = options;
  return client.post<CreateAPIKeyResponse>(requestPath, data, requestOptions);
}
